import { useSelector } from 'react-redux';
import invariant from 'invariant';
import isEqual from 'lodash/isEqual';
import { connectionSelector } from '../components/Connection/selectors';
export const useConnection = ()=>{
    const connection = useSelector((state)=>{
        if (process.env.NODE_ENV !== 'production') {
            invariant(state.connection, `connection is missing in the redux store. Make sure you are using the connectionReducer, e.g.

import { configureStore } from '@reduxjs/toolkit';
import { connectionReducer } from '@cancercentrum/rcc-react';

const store = configureStore({
    reducer:
        connection: connectionReducer,
    },
});
`);
        }
        return connectionSelector(state);
    }, isEqual);
    return connection;
};
export const useConnectionOptional = ()=>{
    const connection = useSelector((state)=>{
        if (!state.connection) {
            return undefined;
        }
        return connectionSelector(state);
    }, isEqual);
    return connection;
};
